export const URL_QUERIES = {
  section: 'section',
  productId: 'productId',
  orderId: 'orderId',
  waitingToShipProduct: 'waitingToShipProduct',
};

export const RESULT_PER_PAGE = 20;
